//@flow
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import FormInput from '../../components/Inputs/FormInput';
import SelectInput from '../../components/Inputs/SelectInput';

type Props = {
  entity: any,
  onChangeDate: any,
  onChangeValue: any,
};

const STATUS_OPTIONS = [
  { value: 'PENDENTE', label: 'Pendente' },
  { value: 'ERRO_REPROCESSAMENTO', label: 'Erro no reprocessamento' },
  { value: 'RESOLVIDA', label: 'Resolvida' },
];

const TIPO_OPTIONS = [
  { value: 'ROLLBACK_RESERVA_PEDIDO', label: 'Rollback reserva pedido' },
  { value: 'ROLLBACK_BAIXA_PEDIDO', label: 'Rollback baixa pedido' },
  { value: 'ROLLBACK_NOTA_FISCAL', label: 'Rollback nota fiscal' },
];

export default class ReprocessamentoEstoqueInternoCrudListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;

    return (
      <React.Fragment>
        <FormGroup className="col-12 col-md-3">
          <SelectInput
            name="status"
            id="status"
            label="Status"
            placeholder="Selecione"
            valueKey="value"
            labelKey="label"
            returnFullObject={false}
            options={STATUS_OPTIONS}
            onChange={(name, value) => {
              this.props.onChangeValue(value, name);
            }}
            value={entity.status}
          />
        </FormGroup>

        <FormGroup className="col-12 col-md-3">
          <SelectInput
            name="tipo"
            id="tipo"
            label="Tipo"
            placeholder="Selecione"
            valueKey="value"
            labelKey="label"
            returnFullObject={false}
            options={TIPO_OPTIONS}
            onChange={(name, value) => {
              this.props.onChangeValue(value, name);
            }}
            value={entity.tipo}
          />
        </FormGroup>

        <FormGroup className="col-12 col-md-2">
          <FormInput
            label="Cliente"
            placeholder="Código do cliente"
            id="codigoCliente"
            name="codigoCliente"
            noSize
            onChange={this.props.onChangeDate}
            type="text"
            value={entity.codigoCliente}
          />
        </FormGroup>

        <FormGroup className="col-12 col-md-2">
          <FormInput
            label="Pedido"
            placeholder="Número do pedido"
            id="numeroPedido"
            name="numeroPedido"
            noSize
            onChange={this.props.onChangeDate}
            type="text"
            value={entity.numeroPedido}
          />
        </FormGroup>

        <FormGroup className="col-12 col-md-2">
          <FormInput
            label="Produto"
            placeholder="Código do produto"
            id="codigoProduto"
            name="codigoProduto"
            noSize
            onChange={this.props.onChangeDate}
            type="text"
            value={entity.codigoProduto}
          />
        </FormGroup>

        <FormGroup className="col-12 col-md-3">
          <FormInput
            label="Referência"
            placeholder="ID de referência"
            id="referenciaId"
            name="referenciaId"
            noSize
            onChange={this.props.onChangeDate}
            type="text"
            value={entity.referenciaId}
          />
        </FormGroup>

        <FormGroup className="col-12 col-md-3">
          <FormInput
            label="Origem"
            placeholder="Origem"
            id="origem"
            name="origem"
            noSize
            onChange={this.props.onChangeDate}
            type="text"
            value={entity.origem}
          />
        </FormGroup>

        <FormGroup className="col-12 col-md-6">
          <FormInput
            label="Mensagem"
            placeholder="Mensagem"
            id="mensagem"
            name="mensagem"
            noSize
            onChange={this.props.onChangeDate}
            type="text"
            value={entity.mensagem}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
